<template>
  <div class="subsection-line">
    <div class="container">
      <h1>왜 많은 분들이 <b>인슈넷FC를 선택하는 걸까요?</b></h1>

      <div
        v-for="(item, index) in introduceList"
        :key="index"
        class="introduce-list"
      >
        <template v-if="index % 2 === 0 || isTouchDevice">
          <span class="item-number">{{ item.index }}</span>
          <div class="image">
            <img :src="`/static/compare/info/select${index + 1}.png`" :alt="item.title">
          </div>
          <div class="desc">
            <p class="title">{{ item.title }}</p>
            <h1 v-html="item.subtitle"></h1>
            <p class="text">{{ item.text }}</p>
          </div>
        </template>

        <template v-else>
          <div class="desc">
            <p class="title">{{ item.title }}</p>
            <h1 v-html="item.subtitle"></h1>
            <p class="text">{{ item.text }}</p>
          </div>
          <div class="image">
            <img :src="`/static/compare/info/select${index + 1}.png`" :alt="item.title">
          </div>
          <span class="item-number">{{ item.index }}</span>
        </template>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isTouchDevice: this.$store.state.config.isTouchDevice,
      introduceList: [
        {
          index: '01',
          title: '37 years of history',
          subtitle: '37년 역사의 믿을 수<br /> 있는 회사입니다.',
          text: '인슈넷에프씨는 1985년부터 시작하여 국내 최대 보험대리점으로 안정성이 높은 회사입니다. 국내 유수의 보험사들로부터 우수대리점상을 20차례 넘게 받았습니다. 보험은 인슈넷에프씨처럼 안정성이 높은 대리점에서 가입해야만 안심할 수 있습니다. (매년 보험설계사의 70%가 폐업하면서 고아계약자가 양산되고 있음)'
        },
        {
          index: '02',
          title: 'Savings on insurance premiums',
          subtitle: '보험료를 절약시켜 드립니다.',
          text: '인슈넷에프씨는 보험사에 종속되지 않은 독립대리점이므로 항상 고객의 입장에서 유리한 보험사를 선택해 드릴 수 있습니다. 독립대리점(GA)임을 내세우는 회사들이 출현하고 있지만 대부분은 재벌기업이나 일부 보험사가 보험판매업에 진출하기 위하여 우회적으로 설립한 기업이기 때문에 고객의 이익과는 무관한 영업을 하고 있습니다. 인슈넷에프씨는 보험사로부터 투자나 재정지원을 받지 않은 명실상부한 독립대리점이므로 항상 고객의 입장에서 유리한 보험사를 선택할 수 있습니다.'
        },
        {
          index: '03',
          title: 'accident compensation',
          subtitle: '사고보상을 제대로 받을 수 있습니다.',
          text: '인슈넷에프씨는 고객으로부터 사고상담이나 보험금 청구를 접수받으면 즉시 사고당담 전문가를 배정하여 보상이 완결될 때까지 도와드립니다. 보험금은 은행 예금처럼 쉽게 찾을 수 없습니다. 보험사는 고객이 낸 보험료보다 훨씬 큰 보험금을 지급하므로 까다로울 수 밖에 없고 그래서 고객에게는 전문성을 갖춘 보험대리점의 도움이 꼭 필요합니다. 인슈넷에프씨는 지금 가능한 보험금의 종류와 구비서류를 안내해 드리고, 대형 대리점으로서의 협상력도 발휘하여 사고보상이 빨리 완결되도록 힘써 드립니다.'
        },
        {
          index: '04',
          title: 'insurance design',
          subtitle: '통합적인 보험설계 서비스를 제공합니다.',
          text: '인슈넷에프씨는 손해보험과 생명보험 상품을 통합하여 고객이 필요한 보장에 꼭 맞는 보험상품을 가입시켜 드립니다. 인슈넷에프씨는 고객이 보장받기 원하는 위험, 보장금액, 보험가입 조건, 보험료 수준 등을 파악하여 손해보험과 생명보험 상품을 통합적으로 설계합니다. 이렇게 해야만 보장누락이나 중복 가입을 피할 수 있기 때문입니다. 인슈넷에프씨는 일부 보험사의 짜집기 통합보험이나 다이렉트 보험사의 단종보험이 도달할 수 없는 통합적인 보험설계 서비스를 제공해 드립니다.'
        },
        {
          index: '05',
          title: 'customer protection',
          subtitle: '24시간 365일 고객을 보호합니다.',
          text: '인슈넷에프씨는 24시간, 365일 보험가입, 계약변경, 계약조회, 사고접수, 긴급출동, 주차알림 등의 서비스를 제공합니다.(단, 보험가입 및 계약변경은 영업시간에만 가능) 인슈넷에프씨는 1년의 100%를 고객지원합니다. 하지만 어느 보험사나 설계사는단 23%(계산근거 : 1년 중 토+일+공휴일 114일로 31%쉬고, 평일 퇴근 후 16시간 미근무로 46% 쉬므로 23%)만 고객지원합니다. 인슈넷에프씨는 특히 사고 발생율이 높은 휴일 및 퇴근 후의 77%당 시간을 고객지원 하여 고객이 무방비 상태에 놓이지 않도록 힘쓰고 있습니다.'
        },
        {
          index: '06',
          title: 'information protection',
          subtitle: '고객의 개인정보를 철저히 보호합니다.',
          text: '인슈넷에프씨는 고객의 개인정보보호 정책을 철저히 시행하고 있을 뿐만 아니라, 추가적인 보안조치에도 많은 비용을 투자하고 있습니다. 인슈넷에프씨의 사내에서 특별히 허가 받은 소수 책임자 외에는 고객의 데이터 서버에 접근할 수 없으며, 홈페이지에서도 보안 모듈을 사용하여 정보유출 방지에 만전을 기하고 기하고 있습니다. 인슈넷에프씨는 보안 이슈가 발생하면 보안 책임자가 즉시 전사원을 교육하며, 별도 독립된 데이터 센터에서 첨단의 보안 시스템을 24시간 가동하고 있습니다'
        },
        {
          index: '07',
          title: 'accident compensation',
          subtitle: '5대 보증, 6대 사은 서비스를 제공합니다.',
          text: '인슈넷에프씨는 5대 보증과 6대 사은 등 다른 보험대리점, 설계사 및 보험사가 따라올 수 없는 서비스를 고객에게 제공합니다. 5대 보증은 최저보험료, 계약철회 환불, 만기완결 알림, 착오계약 리콜, 24시간 근무 등이며 6대 사은은 24시간 주차알림, 긴급견인 20~50Km 추가, 응급치료비 지원, 4대공개 게시판, 12개 보험사 보험료 비교견적, SNS 보험 정보 등 입니다. 인슈넷에프씨는 고객의 위험관리자로서 항상 본연의 역할을 다하겠으며, 고객에게 도움이 되는 새로운 서비스를 개발하는데 게을리하지 않겠습니다.'
        },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.subsection-line {
  background-color: transparent;

  h1 {
    font-size: 2.85*$unit;
    text-align: center;
    font-weight: 100;
    b {
      font-weight: 400;
    }
  }

  .introduce-list {
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    background-color: $color-white;
    margin: 4*$unit 0;

    .item-number {
      position: absolute;
      color: #174be5;
      left: 5*$unit;
      top: -1*$unit;
      transform: translate(-127%, -21%);
      font-size: 7.92*$unit;
      font-weight: 900;
      line-height: 0.56;
      letter-spacing: 1.11px;
      font-family: Roboto, 'NanumSquare';
    }
    .image,
    .desc {
      width: 50%;
      flex: 0 0 auto;
      z-index: 1;
    }
    .image {
      border: unset;
      margin: 0;
      padding: 0;
    }
    .desc {
      padding: 0 2.2*$unit;

      .title {
        font-size: 1.5*$unit;
        font-family: Roboto, 'NanumSquare';
        font-weight: 900;
        text-transform: uppercase;
      }
      h1 {
        font-size: 1.71*$unit;
        margin: 2.57*$unit 2.07*$unit 2.57*$unit 0;
        text-align: left;

        &:first-child {
          margin-right: 6*$unit;
        }
      }
      .text {
        word-break: break-all;
      }
    }

    &:nth-child(odd) {
      .item-number {
        left: unset;
        right: -18*$unit;
        top: -1*$unit;
      }
    }
    &:nth-child(2) {
      .item-number {
        top: -1*$unit;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    @include container("& > .container", 800px);
    .introduce-list {
      .desc {
        .title {
          font-size: 1.2*$unit;
        }
        h1 {
          font-size: 1.5*$unit;
          margin: 2*$unit 1.5*$unit 2*$unit 0;
        }
        p.text {
          font-size: 0.8*$unit;
        }
      }
    }
  }

  @include media-tablet {
    @include container("& > .container", 600px);

    h1 {
      font-size: 1.85*$unit;
    }
    .introduce-list {
      .desc {
        padding: 0 1*$unit;

        .title {
          font-size: 0.8*$unit;
        }
        h1 {
          font-size: 1*$unit;
          margin: 1*$unit 0.5*$unit 1*$unit 0;
        }
      }
    }
  }

  @include media-mobile {
    .introduce-list {
      display: block;
      padding: 0 $unit;

      .item-number {
        left: unset;
        right: -7.5*$unit;
        top: -0.5*$unit;
        font-size: 4.5*$unit;
        line-height: 0.57;

        &:nth-child(odd) {
          right: -7.5*$unit;
          top: -0.5*$unit;
        }
      }

      .image {
        width: 90%;
      }
      .desc {
        width: 100%;
        padding: 0 0.5*$unit;

        p.title {
          font-size: 1*$unit;
        }
        h1 {
          font-size: 1.5*$unit;
          font-weight: 100;
        }
        p.text {
          font-size: 1*$unit;
          font-weight: 100;
        }
      }
    }
  }
}
</style>